import { Injectable } from '@angular/core';
import { CrudConfig, CrudInteractionService, CrudModel, CrudService } from '@ngx-ivengi/crud';
import { Calculation } from './calculation.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class CalculationService extends CrudService<Calculation> {
  public entityType = Calculation;

  constructor(
    protected config: CrudConfig,
    protected http: HttpClient,
    protected interactionService: CrudInteractionService,
  ) {
    super(config, http, interactionService);
  }

  public add(entity: CrudModel) {
    const requestParams = this.getSaveRequestBody(entity);
    return this.http
      .post(`${this.getBaseUrl()}`, requestParams.data, {
        observe: 'response',
        responseType: 'arraybuffer',
        headers: requestParams.headers,
      });
  }

  public getCalculationSheet() {
    return this.http
      .get(`${this.getBaseUrl()}/sheet`, {
        observe: 'response',
        responseType: 'arraybuffer',
      });
  }

  getSaveRequestBody(entity: CrudModel) {
    const headers = new HttpHeaders();
    let data = new FormData();
    const payload = {};
    let isAlsoFileUpload = false;
    const entityKeys = Object.keys(entity);
    for (let i = 0; i < entityKeys.length;  i += 1) {
      if (entity[entityKeys[i]] instanceof FileList) {
        isAlsoFileUpload = true;
        if (entity[entityKeys[i]].length > 1) {
          for (let j = 0; j < entity[entityKeys[j]].length; j++) {
            data.append(entityKeys[j] + '_' + j, entity[entityKeys[i]][j], entity[entityKeys[i]][j].name);
          }
        } else {
          data.append(entityKeys[i], entity[entityKeys[i]][0], entity[entityKeys[i]][0].name);
        }
      } else {
        data.append(entityKeys[i], entity[entityKeys[i]]);
        payload[entityKeys[i]] = entity[entityKeys[i]];
      }
    }
    if (!isAlsoFileUpload) {
      data = entity.toRequest();
    } else {
      data.append('payload', JSON.stringify(payload));
    }
    return {
      data: data,
      headers: headers
    };
  }}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/calculation/calculation.service.ts